import { useEffect, useState } from 'react'
import { navigate } from 'gatsby'
import { clearFormSession, useFirebolt } from '@iq-firebolt/client'
import { trackSubmitingErrors } from 'constants/analytics'
import useAnalytics from './useAnalytics'

export default function useRedirectTransitionError(error) {
  const [redirectTransitionError, setRedirectTransitionError] = useState(false)
  const [redirectToUrl, setRedirectToUrl] = useState(false)

  const { setFlow } = useAnalytics()
  const { remoteErrors, ...props } = useFirebolt()

  const errorMessages = Object.keys(error)

  useEffect(() => {
    const hasError = remoteErrors[0]?.validationResults[0].message

    setFlow(props.capturedData.track)

    if (errorMessages.includes(hasError)) {
      const pathUrl = error[hasError]

      setRedirectToUrl(true)
      navigate(pathUrl)

      setTimeout(() => {
        clearFormSession()
      }, 500)
    } else {
      setRedirectTransitionError(true)
    }
  }, [remoteErrors])
  return {
    redirectTransitionError,
    redirectToUrl,
  }
}
